import { useState } from 'react';
import { useDispatch } from 'react-redux';

import api from 'api';
import { TicketStatus } from 'api/models/payload/Ticket';
import { getErrorMessage } from 'utils/v2/errorHelper';
import { setAlert } from 'redux/alert';
import { AppDispatch } from 'redux/store';
import type { TicketInterface } from 'types';

const useTickets = () => {
    const dispatch: AppDispatch = useDispatch();
    const [tickets, setTickets] = useState<TicketInterface[]>([]);
    const [isLoadingTickets, setIsLoadingTickets] = useState<boolean>(false);

    const fetchTickets = async (applicationId: string) => {
        try {
            setIsLoadingTickets(true);
            const response = await api.tickets.getTicketsByApplication(applicationId);
            setTickets(response.data as unknown as TicketInterface[]);
        } catch (error) {
            dispatch(
                setAlert({
                    message: getErrorMessage(error, 'Failed to fetch tickets'),
                    type: 'error',
                })
            );
        } finally {
            setIsLoadingTickets(false);
        }
    };

    const resolveTicket = async (
        ticketId: number,
        status: string,
        applicationId: string
    ): Promise<boolean> => {
        try {
            await api.tickets.editTicket({ id: ticketId, status: status as TicketStatus });
            await fetchTickets(applicationId);
            return true;
        } catch (error) {
            dispatch(
                setAlert({
                    message: getErrorMessage(error, 'Failed to update ticket'),
                    type: 'error',
                })
            );
            return false;
        }
    };

    return { tickets, isLoadingTickets, fetchTickets, resolveTicket };
};

export default useTickets;
